import * as gtag from "../../utils/gtag";

export const sendClickUpload = () => {
    gtag.overallEvent(`click_upload`, `dropzone-main`);
}

export const sendAddError = (error: string) => {
    gtag.overallEvent(`add_error`, error);
}

export const sendClickTool = (service: string) => {
    gtag.overallEvent(`click_service_tool_${service}`, `unknown`);
}

export const sendClickHorizontal = () => {
    gtag.overallEvent(`click_flip_horizontal`, `unknown`);
}

export const sendClickVertical = () => {
    gtag.overallEvent(`click_flip_vertical`, `unknown`);
}

export const sendClickDownloadFlipper = (label) => {
    gtag.overallEvent(`click_download_flipper`, label);
}

export const sendUploadBtnClick = (label: string) => {
    gtag.overallEvent('click_upload', label);
}

export const sendChangeSaveProporsion = (isSave) => {
    gtag.overallEvent('click_lock', isSave ? 'on' : 'off');
}

export const sendClickRotateRight = () => {
    gtag.overallEvent('click_rotate_right   ', `unknown`);
}

export const sendClickRotateLeft = () => {
    gtag.overallEvent('click_rotate_left', `unknown`);
}

export const sendChangeSelectFormat = (format: string) => {
    gtag.overallEvent('click_out_format', format);
}

export const sendDownloadEvent = (service: string, properties: {rotate: number, widthIn: number, heightIn: number, widthOut: number, heightOut: number, isFlipVertical: boolean, isFlipHorizontal: boolean, formatOut: string, formatIn: string}) => {
    let label = `unknown`;

    switch(service) {
        case 'rotator':
            label = `${properties.rotate > 0 ? 'right' : properties.rotate < 0 ? 'left' : 'without_changes'}`
            break;
        case 'cropper':
            label = `${properties.widthIn}x${properties.heightIn}|${properties.widthOut}x${properties.heightOut}`
            
            break;
        case 'flipper':
            label = `without_changes`;
            label = properties.isFlipVertical ? `vertical` : label;
            label = properties.isFlipHorizontal ? `horizontal` : label;
            label = properties.isFlipHorizontal && properties.isFlipVertical ? `horizontal|vertical` : label;           
            break;
        case 'resizer':
            label = `${properties.formatIn}|${properties.widthIn}x${properties.heightIn}|${properties.formatOut}|${properties.widthOut}x${properties.heightOut}`;
            break;
    }

    gtag.overallEvent(`click_download_${service}`, label);
}

export const sendClickReset = () => {
    gtag.overallEvent('click_reset', `unknown`);
}

export const sendClickCrop = (originalWidth: number, originalHeight: number, cropWidth: number, cropHeight: number) => {
    gtag.overallEvent('click_crop', `${originalWidth}x${originalHeight}|${cropWidth}x${cropHeight}`);
}

export const sendChangeDimensiom = (width: number, height: number, changeDimension: string) => {
    gtag.overallEvent('edit_width_height', `${changeDimension}|${width}x${height}`);
}

export const sendShowRemovePopup = () => {
    gtag.overallEvent('show_popup_remove_image', 'unknown');
}